<div class="row fuelux">
	<div class="col-lg-12">
		<div class="main-box clearfix">
			<div class="main-box-body clearfix wizardmainbox">
				<div class="row">
					<div class="col-lg-12">
						<div class="main-box clearfix" style="min-height: 200px;">
							<div class="row">
								<form role="form" #uploadResumesForm="ngForm" novalidate>
									<div class="col-lg-5 col-lg-offset-1"
										style="margin-top: 2%; padding: 0 20px 20px 20px;">
										<div class="form-group">
											<label for="sourceType" class="control-label">
												{{MESSAGECONSTANTS.LABLES.UPLOAD_RESUME.SOURCE_TYPE}}
												<em> * </em> :
											</label>
											<select class="form-control" name="sourceType" id="sourceType"
												[(ngModel)]="sourceType" (ngModelChange)="sourceTypeChanged()"
												[disabled]="disableSourceTypesFlag" required>
												<option *ngFor="let source of sourceTypeList" [ngValue]="source">{{source.sourceType}}</option>
											</select>
										</div>
										<div class="form-group" *ngIf="sourceType?.sourceType == 'Other'">
											<label for="otherSourceTypeNotes" class="control-label">
												Notes<em> * </em> :
											</label>
										<!-- Voice Input -->
										<div class="mb-2">
											<app-voice-input
												(transcriptReady)="onVoiceTranscript($event)"
												[candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
												[company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
												[requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
												[jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null"
												[sourceScreen]="sourceScreen">
											</app-voice-input>
										</div>
										<textarea class="form-control" name="otherSourceTypeNotes"
											id="otherSourceTypeNotes" maxlength="503"
											[(ngModel)]="otherSourceTypeNotes" required
											[disabled]="disableSourceTypesFlag">
										</textarea>
										<!-- Formalize Text -->
										<app-formalize-comment
											[inputText]="otherSourceTypeNotes"
											(outputText)="receiveFormalizedComment($event)"
											[candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
											[company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
											[requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
											[jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null"
											[sourceScreen]="sourceScreen">
										</app-formalize-comment>
										</div>
										<div class="form-group" *ngIf="sourceType?.sourceType == 'Referral'">
											<label for="referrerName" class="control-label">
												Referrer Name<em> * </em> :
											</label>
											<input type="text" class="form-control" name="referrerName"
												id="referrerName" [(ngModel)]="referrerName" required
												[disabled]="disableSourceTypesFlag">
										</div>
										<div class="form-group" *ngIf="sourceType?.sourceType == 'Referral'">
											<label for="referrerEmail" class="control-label">
												Referrer Email<em> * </em> :
											</label>
											<input type="email" name="referrerEmail" id="referrerEmail"
												class="form-control" placeholder="example@example.com"
												[(ngModel)]="referrerEmail"
												[pattern]="MESSAGECONSTANTS.VALIDATIONPATTERNS.EMAIL"
												required [disabled]="disableSourceTypesFlag" #referrerEmailField="ngModel">
											<span class="help-block">ex. example@example.com</span>
											<small class="error" *ngIf="referrerEmailField.dirty && referrerEmailField.invalid">
												{{MESSAGECONSTANTS.COMMONVALIDATIONS.NOT_VALID_EMAIL}}
											</small>
										</div>
									</div>
									<div class="col-lg-4 col-lg-offset-1" style="margin-top: 2%; padding: 0px 26px 20px 20px;">
										<div>
											<label for="displayUploadDate" class="control-label" >Upload Date <em> * </em> :</label>
											<div class="input-group">
												<span class="input-group-addon cursor-pointer" (click)="openUploadDatePicker()">
													<i class="fa fa-calendar"></i>
												</span>
												<input type="text" class="form-control" placeholder="mm-dd-yyyy" id="displayUploadDate" name="displayUploadDate"
													[(ngModel)]="displayUploadDate" required>
											</div>
										</div>
									</div>
								</form>
							</div>
							<div class="main-box-body clearfix col-lg-10 col-lg-offset-1">
								<div>
									<form name="resumeUploadDropzone" id="resumeUploadDropzone"
										class="dropzone dz-clickable" action="" enctype="multipart/form-data"
										[dropzone]="dropzoneConfig" (addedFile)="onFileAdded($event)" (maxFilesExceeded)="onMaxFilesExceeded($event)"
										(removedFile)="onFileRemoved($event)" (sendingMultiple)="onFileSendingMultiple($event)"
										(successMultiple)="onFileSuccessMultiple($event)" (error)="onFileError($event)">
										<div class="dz-a dz-default dz-message">
											<span>
												<h3>Drop files here to upload</h3>(or click)
											</span>
										</div>
									</form>
								</div>
							</div>
							<!-- Upload Requisition button -->
							<div class="row buttonrow" style="margin-bottom: 200px">
								<div class="col-xs-12 col-sm-offset-4 col-sm-4">
									<button type="button" class="btn btn-success col-xs-12" id="uploadFile"
										(click)="uploadResumes(uploadResumesForm)" [disabled]="disableUploadButtonFlag">
										<i class="fa fa-upload mr-2"></i>
										<span *ngIf="!fileUploadInProgressFlag">Upload </span><span
											*ngIf="fileUploadInProgressFlag">Uploading... </span> Resume
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
